export default function EmergencyBlock() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-20 bg-[#1A1A1A] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/4 w-80 h-80 bg-white/3 rounded-full -translate-y-1/2 blur-3xl"></div>
        <div className="absolute top-1/2 right-1/4 w-60 h-60 bg-white/3 rounded-full -translate-y-1/2 blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-10 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 text-center md:text-left">
          <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-white/10 border border-white/10 flex-shrink-0 mx-auto md:mx-0">
            <i className="ri-flashlight-fill text-4xl text-yellow-400"></i>
          </div>

          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
              Kurzfristiger Einsatz? Kein Problem.
            </h2>
            <p className="text-gray-400 text-base leading-relaxed">
              Wenn ein Dienstleister ausfällt oder es dringend wird, springen wir kurzfristig ein und sorgen sofort für stabile Abläufe – ohne lange Wartezeiten.
            </p>
            <p className="text-gray-500 text-sm mt-2 flex items-center gap-2 justify-center md:justify-start">
              <i className="ri-time-line text-green-400"></i>
              Reaktionszeit unter 24 Stunden
            </p>
          </div>

          <div className="flex-shrink-0">
            <button
              onClick={() => scrollTo("kontakt")}
              className="bg-white text-black font-bold px-8 py-4 rounded-full hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-base"
            >
              <i className="ri-phone-line"></i>
              Jetzt Notfall melden
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
